export default __webpack_public_path__ + "static/media/3@3x.c2546d33.png";